<script>
    import { closeModal } from "svelte-modals";
    import { fly } from "svelte/transition";
    import { createForm } from "svelte-forms-lib";
    import * as yup from "yup";
    import InputField from "../Forms/InputField.svelte";

    export let isOpen;
    export let title;
    export let message;
    export let onConfirm;
    export let min;
    export let max;

    const {
        form,
        handleChange,
        handleSubmit,
        errors,
        isValid
    } = createForm({
        initialValues: { value: min },
        onSubmit: (form) => onConfirm(+form.value),
        validationSchema: yup.object().shape({
            value: yup.number().typeError("Inserisci un numero corretto")
                .max(max, `Inserisci un numero minore di ${max}`)
                .min(min, `Inserisci un numero maggiore di ${min}`)
                .required("Inserisci un numero")
        })
    });
</script>

{#if isOpen}
    <div
        class="custom-modal shadow-md flex flex-col justify-between h-64"
        transition:fly={{ y: -100 }}
        on:introstart
        on:outroend
    >
        <div class="flex flex-col gap-1">
            <div class="text-3xl font-bold text-bl">{title}</div>
            <div class="text-xl">{message}</div>
        </div>

        <InputField
            isRequired={false}
            name="value"
            type="number"
            handleChange={handleChange}
            bind:value={$form.value}
            bind:errorText={$errors.value}
        />

        <div class="flex justify-end gap-3">
            <button
                disabled={!$isValid}
                on:click={handleSubmit}
                class:bg-opacity-20={!$isValid}
                class="bg-lightBlue-500 p-2 px-4 font-semibold text-white hover:shadow-lg"
            >
                Conferma
            </button>
            <button class="border-0 bg-blueGray-600 p-2 px-4 font-semibold text-white hover:shadow-lg" on:click={closeModal}>Annulla</button>
        </div>
    </div>
{/if}